import { useState } from 'react';
import '../styles/design-tokens.css';
import PageLayout from '../components/home/PageLayout';

export default function CareerPage() {
  const [form, setForm] = useState({
    name: '',
    mobile: '',
    email: '',
    qualification: '',
    experience: '',
    position: '',
    message: '',
  });
  const [sent, setSent] = useState(false);

  const handleChange = e =>
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    setSent(true);
    setForm({
      name: '',
      mobile: '',
      email: '',
      qualification: '',
      experience: '',
      position: '',
      message: '',
    });
  };

  return (
    <PageLayout title="JOIN US" breadcrumb="JOIN US">

      {/* ── Contact Us Page 2 Area ── */}
      <div className="sa-cp-area">
        <div className="sa-container">

          <div className="sa-cp-row">

            {/* ── LEFT: Information column (col-lg-4) ── */}
            <div className="sa-cp-info-col">
              <h2 className="sa-cp-title-left">Information</h2>
              <span className="sa-cp-title-bar"></span>

              <div>
                <ul className="sa-cp-info-list">
                  <li>
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                    Somayya Academy Parthasarathi Building, Near City Pride-Kothrud, Kothrud, Pune – 411038
                  </li>
                  <li>
                    <i className="fa fa-phone" aria-hidden="true"></i>
                    +91 9511840674
                  </li>
                  <li>
                    <i className="fa fa-envelope-o" aria-hidden="true"></i>
                    info@somayyaacademy.com
                  </li>
                </ul>
              </div>
            </div>

            {/* ── RIGHT: Form column (col-lg-8) ── */}
            <div className="sa-cp-form-col">

              {/* Title with red bar — matches h2.title-bar-high */}
              <h2 className="sa-cp-title-right">
                You are requested to drop your CVs at career@somayyaacademy.com
              </h2>
              <span className="sa-cp-title-bar"></span>

              {/* ── Form area (.contact-form2) ── */}
              <div>
                {sent ? (
                  <div className="sa-cp-success">
                    <i className="fa fa-check-circle" aria-hidden="true"></i>
                    Thank you! Your message has been sent successfully.
                  </div>
                ) : (
                  <form id="contact-form" onSubmit={handleSubmit} noValidate>

                    {/* Row 1: Name + Mobile Number */}
                    <div className="sa-cp-form-grid">
                      <div className="sa-cp-col-half">
                        <div className="sa-cp-form-group">
                          <input
                            type="text"
                            placeholder="Name*"
                            name="name"
                            id="form-name"
                            className="sa-cp-input"
                            value={form.name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="sa-cp-col-half">
                        <div className="sa-cp-form-group">
                          <input
                            type="number"
                            placeholder="Mobile Number*"
                            name="mobile"
                            id="form-number"
                            className="sa-cp-input"
                            value={form.mobile}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    {/* Row 2: Email + Educational Qualification */}
                    <div className="sa-cp-form-grid">
                      <div className="sa-cp-col-half">
                        <div className="sa-cp-form-group">
                          <input
                            type="email"
                            placeholder="Email*"
                            name="email"
                            id="form-email"
                            className="sa-cp-input"
                            value={form.email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="sa-cp-col-half">
                        <div className="sa-cp-form-group">
                          <input
                            type="text"
                            placeholder="Educational Qualification*"
                            name="qualification"
                            id="form-qualification"
                            className="sa-cp-input"
                            value={form.qualification}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    {/* Row 3: Experience + Position Sought */}
                    <div className="sa-cp-form-grid">
                      <div className="sa-cp-col-half">
                        <div className="sa-cp-form-group">
                          <input
                            type="text"
                            placeholder="Experience*"
                            name="experience"
                            id="form-experience"
                            className="sa-cp-input"
                            value={form.experience}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="sa-cp-col-half">
                        <div className="sa-cp-form-group">
                          <input
                            type="text"
                            placeholder="Position Sought*"
                            name="position"
                            id="form-position"
                            className="sa-cp-input"
                            value={form.position}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Row 4: Message (full width) */}
                    <div className="sa-cp-form-grid">
                      <div className="sa-cp-col-full">
                        <div className="sa-cp-form-group">
                          <textarea
                            placeholder="Message*"
                            name="message"
                            id="form-message"
                            rows="8"
                            cols="20"
                            className="sa-cp-input sa-cp-textarea"
                            value={form.message}
                            onChange={handleChange}
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    {/* Row 5: Submit button (col-lg-4 / col-md-4 / col-sm-6) */}
                    <div className="sa-cp-form-grid">
                      <div className="sa-cp-col-btn">
                        <div className="sa-cp-form-group">
                          <button
                            type="submit"
                            className="sa-cp-submit-btn"
                          >
                            Send Message
                          </button>
                        </div>
                      </div>
                    </div>

                  </form>
                )}
              </div>
            </div>
            {/* END right col */}

          </div>
          {/* END .sa-cp-row */}

        </div>
        {/* END .sa-container */}
      </div>
      {/* END .sa-cp-area */}

      {/* ── Google Map — full bleed (container-fluid equivalent) ── */}
      <div className="sa-cp-map-area">
        <iframe
          title="Somayya Academy Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d50908.749654937244!2d73.79891784822044!3d18.492016523208015!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xafcd8d4ed94eaf03!2sSomayya%20Engineering%20Academy!5e0!3m2!1sen!2sin!4v1614315337476!5m2!1sen!2sin"
          width="100%"
          height="395"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>

    </PageLayout>
  );
}
